import * as React from "react";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = { credentials: { email: "", password: "" } };
  }

  render() {
    return (<>
<div id="db-page-wrapper">
  <div className="page-content-tab">
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-12">
          <div className="page-title-box">
            <h1 className="page-title"><span className="page-title-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M19.9412 7.78071L13.9677 2.71116C12.8135 1.73166 11.1104 1.76547 9.99604 2.79002L3.96956 8.33074C3.35165 8.89884 3 9.69982 3 10.5392V19.0013C3 20.6582 4.34315 22.0013 6 22.0013H18C19.6569 22.0013 21 20.6582 21 19.0013V10.068C21 9.18711 20.6128 8.35072 19.9412 7.78071ZM11.3497 4.26233C11.7211 3.92081 12.2888 3.90954 12.6735 4.23604L18.6471 9.30559C18.8709 9.49559 19 9.77439 19 10.068V19.0013C19 19.5536 18.5523 20.0013 18 20.0013H16C16 19.9988 16 19.9962 16 19.9936V15.0283C16 13.9237 15.1046 13.0283 14 13.0283H10C8.89543 13.0283 8 13.9237 8 15.0283V19.9936C8 19.9962 8 19.9988 8.00001 20.0013H6C5.44772 20.0013 5 19.5536 5 19.0013V10.5392C5 10.2594 5.11722 9.99241 5.32319 9.80304L11.3497 4.26233ZM10 15.0283H14V19.9936H10V15.0283Z" fill="white"/>
              </svg>
              </span>Dashboard</h1>
            <button className="button-menu-mobile nav-link text-center hidden-lg">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16" cy="16" r="16" fill="#0A6CFF"/>
              <path fillRule="evenodd" clipRule="evenodd" d="M12 9.33333H20C21.4728 9.33333 22.6667 10.5272 22.6667 12V20C22.6667 21.4728 21.4728 22.6667 20 22.6667H12C10.5272 22.6667 9.33333 21.4728 9.33333 20V12C9.33333 10.5272 10.5272 9.33333 12 9.33333ZM21.3333 12C21.3333 11.2636 20.7364 10.6667 20 10.6667H12C11.2636 10.6667 10.6667 11.2636 10.6667 12V20C10.6667 20.7364 11.2636 21.3333 12 21.3333H20C20.7364 21.3333 21.3333 20.7364 21.3333 20V12ZM15.8047 13.5286C15.5444 13.2682 15.1223 13.2682 14.8619 13.5286C14.6016 13.7889 14.6016 14.2111 14.8619 14.4714L16.3905 16L14.8619 17.5286C14.6016 17.7889 14.6016 18.2111 14.8619 18.4714C15.1223 18.7318 15.5444 18.7318 15.8047 18.4714L17.8047 16.4714C18.0651 16.2111 18.0651 15.7889 17.8047 15.5286L15.8047 13.5286Z" fill="white"/>
            </svg>
            </button>
          </div>
        </div>
      </div>
      {/* <section id="owlCarousel">
        <div className="row">
          <div className="col-md-12 columns">
            <div className="owl-carousel owl-theme">
              <div className="item">
                <div className="stretch-card grid-margin">
                  <div className="card card-rounded bg-cornflower-blue card-img-holder text-center">
                    <div className="card-body"> <img src="assets/images/circle.svg" className="card-img-absolute" alt="circle-image"/>
                      <svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="43" cy="43" r="43" fill="white"/>
                        <path d="M54.6667 28H31.3333C29.4924 28 28 29.4924 28 31.3333V54.6667C28 56.5076 29.4924 58 31.3333 58H54.6667C56.5076 58 58 56.5076 58 54.6667V31.3333C58 29.4924 56.5076 28 54.6667 28Z" stroke="#004DFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M28 38H58" stroke="#004DFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M38 58V38" stroke="#004DFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <h4 className="card-text">Pick a Template</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="stretch-card grid-margin">
                  <div className="card card-rounded bg-mountain-meadow card-img-holder text-center">
                    <div className="card-body"> <img src="assets/images/circle.svg" className="card-img-absolute" alt="circle-image"/>
                      <svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="43" cy="43" r="43" fill="white"/>
                        <path d="M59.6666 43H49.6666L46.3333 48H39.6666L36.3333 43H26.3333" stroke="#24CF85" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M32.0833 31.5166L26.3333 43V53C26.3333 53.884 26.6845 54.7319 27.3096 55.357C27.9347 55.9821 28.7826 56.3333 29.6666 56.3333H56.3333C57.2173 56.3333 58.0652 55.9821 58.6903 55.357C59.3154 54.7319 59.6666 53.884 59.6666 53V43L53.9166 31.5166C53.6407 30.9613 53.2153 30.4939 52.6882 30.1671C52.1612 29.8403 51.5534 29.667 50.9333 29.6666H35.0666C34.4465 29.667 33.8387 29.8403 33.3117 30.1671C32.7847 30.4939 32.3593 30.9613 32.0833 31.5166V31.5166Z" stroke="#24CF85" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <h4 className="card-text">Add products</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="stretch-card grid-margin">
                  <div className="card card-rounded bg-yellow-orange card-img-holder text-center">
                    <div className="card-body"> <img src="assets/images/circle.svg" className="card-img-absolute" alt="circle-image"/>
                      <svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="43" cy="43" r="43" fill="white"/>
                        <path d="M46.3334 26.3334H33C32.116 26.3334 31.2681 26.6845 30.643 27.3097C30.0179 27.9348 29.6667 28.7826 29.6667 29.6667V56.3334C29.6667 57.2174 30.0179 58.0653 30.643 58.6904C31.2681 59.3155 32.116 59.6667 33 59.6667H53C53.8841 59.6667 54.7319 59.3155 55.3571 58.6904C55.9822 58.0653 56.3334 57.2174 56.3334 56.3334V36.3334L46.3334 26.3334Z" stroke="#FF9600" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M46.3333 26.3334V36.3334H56.3333" stroke="#FF9600" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M49.6666 44.6666H36.3333" stroke="#FF9600" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M49.6666 51.3334H36.3333" stroke="#FF9600" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M39.6666 38H38H36.3333" stroke="#FF9600" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <h4 className="card-text">Add catalog</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="stretch-card grid-margin">
                  <div className="card card-rounded bg-light-slate-blue card-img-holder text-center">
                    <div className="card-body"> <img src="assets/images/circle.svg" className="card-img-absolute" alt="circle-image"/>
                      <svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="43" cy="43" r="43" fill="white"/>
                        <path d="M43 48C45.7614 48 48 45.7614 48 43C48 40.2386 45.7614 38 43 38C40.2386 38 38 40.2386 38 43C38 45.7614 40.2386 48 43 48Z" stroke="#7E00FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M55.3334 48C55.1115 48.5027 55.0453 49.0603 55.1434 49.601C55.2414 50.1416 55.4991 50.6405 55.8834 51.0333L55.9834 51.1333C56.2933 51.4429 56.5392 51.8105 56.7069 52.2152C56.8747 52.6198 56.961 53.0536 56.961 53.4916C56.961 53.9297 56.8747 54.3635 56.7069 54.7681C56.5392 55.1728 56.2933 55.5404 55.9834 55.85C55.6738 56.1599 55.3062 56.4058 54.9015 56.5735C54.4968 56.7413 54.0631 56.8276 53.625 56.8276C53.187 56.8276 52.7532 56.7413 52.3486 56.5735C51.9439 56.4058 51.5763 56.1599 51.2667 55.85L51.1667 55.75C50.7739 55.3657 50.275 55.108 49.7344 55.01C49.1937 54.9119 48.6361 54.9781 48.1334 55.2C47.6404 55.4112 47.22 55.7621 46.9239 56.2092C46.6278 56.6564 46.4688 57.1803 46.4667 57.7166V58C46.4667 58.884 46.1155 59.7319 45.4904 60.357C44.8653 60.9821 44.0174 61.3333 43.1334 61.3333C42.2493 61.3333 41.4015 60.9821 40.7764 60.357C40.1512 59.7319 39.8 58.884 39.8 58V57.85C39.7871 57.2983 39.6086 56.7633 39.2876 56.3145C38.9665 55.8657 38.5179 55.5238 38 55.3333C37.4973 55.1115 36.9397 55.0453 36.3991 55.1433C35.8584 55.2413 35.3595 55.4991 34.9667 55.8833L34.8667 55.9833C34.5571 56.2932 34.1895 56.5391 33.7848 56.7068C33.3802 56.8746 32.9464 56.9609 32.5084 56.9609C32.0703 56.9609 31.6366 56.8746 31.2319 56.7068C30.8272 56.5391 30.4596 56.2932 30.15 55.9833C29.8401 55.6737 29.5943 55.3061 29.4265 54.9014C29.2588 54.4968 29.1724 54.063 29.1724 53.625C29.1724 53.1869 29.2588 52.7532 29.4265 52.3485C29.5943 51.9438 29.8401 51.5762 30.15 51.2666L30.25 51.1666C30.6343 50.7738 30.892 50.275 30.99 49.7343C31.0881 49.1936 31.0219 48.636 30.8 48.1333C30.5888 47.6404 30.238 47.2199 29.7908 46.9238C29.3437 46.6277 28.8197 46.4688 28.2834 46.4666H28C27.116 46.4666 26.2681 46.1155 25.643 45.4903C25.0179 44.8652 24.6667 44.0174 24.6667 43.1333C24.6667 42.2493 25.0179 41.4014 25.643 40.7763C26.2681 40.1512 27.116 39.8 28 39.8H28.15C28.7017 39.7871 29.2367 39.6085 29.6855 39.2875C30.1344 38.9665 30.4762 38.5179 30.6667 38C30.8886 37.4973 30.9547 36.9397 30.8567 36.399C30.7587 35.8583 30.5009 35.3594 30.1167 34.9666L30.0167 34.8666C29.7068 34.5571 29.4609 34.1894 29.2932 33.7848C29.1254 33.3801 29.0391 32.9464 29.0391 32.5083C29.0391 32.0703 29.1254 31.6365 29.2932 31.2318C29.4609 30.8272 29.7068 30.4596 30.0167 30.15C30.3263 29.8401 30.6939 29.5942 31.0986 29.4264C31.5032 29.2587 31.937 29.1724 32.375 29.1724C32.8131 29.1724 33.2468 29.2587 33.6515 29.4264C34.0562 29.5942 34.4238 29.8401 34.7334 30.15L34.8334 30.25C35.2262 30.6342 35.7251 30.892 36.2657 30.99C36.8064 31.088 37.364 31.0218 37.8667 30.8H38C38.493 30.5887 38.9134 30.2379 39.2095 29.7908C39.5057 29.3436 39.6646 28.8196 39.6667 28.2833V28C39.6667 27.1159 40.0179 26.2681 40.643 25.643C41.2681 25.0178 42.116 24.6666 43 24.6666C43.8841 24.6666 44.7319 25.0178 45.3571 25.643C45.9822 26.2681 46.3334 27.1159 46.3334 28V28.15C46.3355 28.6863 46.4944 29.2103 46.7906 29.6574C47.0867 30.1046 47.5071 30.4554 48 30.6666C48.5027 30.8885 49.0604 30.9547 49.601 30.8567C50.1417 30.7586 50.6406 30.5009 51.0334 30.1166L51.1334 30.0166C51.4429 29.7067 51.8106 29.4609 52.2152 29.2931C52.6199 29.1254 53.0537 29.039 53.4917 29.039C53.9298 29.039 54.3635 29.1254 54.7682 29.2931C55.1728 29.4609 55.5405 29.7067 55.85 30.0166C56.16 30.3262 56.4058 30.6939 56.5736 31.0985C56.7413 31.5032 56.8277 31.9369 56.8277 32.375C56.8277 32.813 56.7413 33.2468 56.5736 33.6514C56.4058 34.0561 56.16 34.4237 55.85 34.7333L55.75 34.8333C55.3658 35.2261 55.1081 35.725 55.01 36.2657C54.912 36.8063 54.9782 37.364 55.2 37.8666V38C55.4113 38.4929 55.7621 38.9133 56.2093 39.2095C56.6564 39.5056 57.1804 39.6645 57.7167 39.6666H58C58.8841 39.6666 59.7319 40.0178 60.3571 40.643C60.9822 41.2681 61.3334 42.1159 61.3334 43C61.3334 43.884 60.9822 44.7319 60.3571 45.357C59.7319 45.9821 58.8841 46.3333 58 46.3333H57.85C57.3137 46.3355 56.7897 46.4944 56.3426 46.7905C55.8954 47.0866 55.5446 47.507 55.3334 48V48Z" stroke="#7E00FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <h4 className="card-text">Customize my site</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <h2 className="graph header-title">Revenue</h2>
          <div className="card card-rounded overflow">
            <div className="single">
              <div className="card-body box">
                <h2 className="header-title none-xs">Revenue</h2>
                <div className="row">
                  <div className="col-md-12">
                    <div className="media">
                      <div className="media-body"> <span className="title-price">$7,825</span> <span className="content-text">+ 22%</span> </div>
                    </div>
                    <canvas id="bar" className="drop-shadow"></canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <h2 className="graph header-title ">Orders</h2>
          <div className="card card-rounded overflow">
            <div className="single">
              <div className="card-body box">
                <h2 className="header-title none-xs">Orders</h2>
                <div className="row">
                  <div className="col-md-12">
                    <div className="media">
                      <div className="media-body"> <span className="title-price">1220</span> <span className="content-text dust-red">- 25%</span> </div>
                    </div>
                    <canvas id="bar2" className="drop-shadow"></canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <h2 className="graph header-title">Latest Orders</h2>
          <div className="card card-rounded overflow">
            <div className="single">
              <div className="card-body box">
                <h2 className="header-title none-xs">Latest Orders</h2>
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead className="thead-light">
                      <tr>
                        <th>Order Number</th>
                        <th>Order Date</th>
                        <th>Order Total</th>
                        <th>Order Status</th>
                      </tr>
                    
                    </thead>
                    <tbody>
                      <tr>
                        <td>6690</td>
                        <td>Sep 6, 2012 4:18 AM</td>
                        <td>$948.55</td>
                        <td><span className="badge badge-md badge-solitude">Entered</span></td>
                      </tr>
                     
                      <tr>
                        <td>4600</td>
                        <td>Oct 4, 2013 5:10 PM</td>
                        <td>$328.85</td>
                        <td><span className="badge badge-md badge-solitude">Entered</span></td>
                      </tr>
                    
                      <tr>
                        <td>6025</td>
                        <td>Jan 5, 2020 9:31 AM</td>
                        <td>$106.58</td>
                        <td><span className="badge badge-md badge-solitude">Entered</span></td>
                      </tr>
                    
                      <tr>
                        <td>9462</td>
                        <td>Jun 1, 2020 5:21 PM</td>
                        <td>$446.61</td>
                        <td><span className="badge badge-md badge-solitude">Entered</span></td>
                      </tr>
                    
                      <tr>
                        <td>8811</td>
                        <td>Jan 4, 2016 4:12 AM</td>
                        <td>$219.78</td>
                        <td><span className="badge badge-md badge-magnolia">Booked</span></td>
                      </tr>
                   
                      <tr>
                        <td>1148</td>
                        <td>Mar 4, 2014 5:50 PM</td>
                        <td>$778.35</td>
                        <td><span className="badge badge-md badge-alice-blue">In process</span></td>
                      </tr>
                     
                      <tr>
                        <td>5045</td>
                        <td>Jan 30, 2020 9:20 AM</td>
                        <td>$202.87</td>
                        <td><span className="badge badge-md badge-moccasin">Shipped</span></td>
                      </tr>
                     
                      <tr>
                        <td>1577</td>
                        <td>Sep 6, 2012 4:18 AM</td>
                        <td>$105.55</td>
                        <td><span className="badge badge-md badge-cosmic-latte">Closed</span></td>
                      </tr>
                     
                      <tr>
                        <td>5560</td>
                        <td>Sep 6, 2012 4:18 AM</td>
                        <td>$475.22</td>
                        <td><span className="badge badge-md badge-misty-rose">Cancelled</span></td>
                      </tr>
                    
                      <tr>
                        <td>7791</td>
                        <td>Sep 6, 2012 4:18 AM</td>
                        <td>$275.43</td>
                        <td><span className="badge badge-md badge-astronaut">Back Ordered</span></td>
                      </tr>
                    
                    </tbody>
                  </table>
                </div>
                <div className="text-right">
                  <button type="button" className="btn btn-primary" title="View all orders">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M12 12.6667L11.3333 12.6667C11.3333 13.7712 10.4379 14.6667 9.33333 14.6667H4C2.89543 14.6667 2 13.7712 2 12.6667V5.33333C2 4.22876 2.89543 3.33333 4 3.33333C4 2.22876 4.89543 1.33333 6 1.33333H12C13.1046 1.33333 14 2.22876 14 3.33333L14 10.6667C14 11.7712 13.1046 12.6667 12 12.6667ZM10.6667 11.3333L10.6656 11.3333L6 11.3333C5.63181 11.3333 5.33333 11.0349 5.33333 10.6667L5.33333 4V3.33333C5.33333 2.96514 5.63181 2.66667 6 2.66667L12 2.66667C12.3682 2.66667 12.6667 2.96514 12.6667 3.33333L12.6667 10.6667C12.6667 11.0349 12.3682 11.3333 12 11.3333H10.6677L10.6667 11.3333ZM3.33333 5.33333C3.33333 4.96514 3.63181 4.66667 4 4.66667L4 10.6667C4 11.7712 4.89543 12.6667 6 12.6667L10 12.6667C10 13.0349 9.70152 13.3333 9.33333 13.3333H4C3.63181 13.3333 3.33333 13.0349 3.33333 12.6667V5.33333ZM7.33333 4C6.96514 4 6.66667 4.29848 6.66667 4.66667C6.66667 5.03486 6.96514 5.33333 7.33333 5.33333H10.6667C11.0349 5.33333 11.3333 5.03486 11.3333 4.66667C11.3333 4.29848 11.0349 4 10.6667 4H7.33333ZM6.66667 7C6.66667 6.63181 6.96514 6.33333 7.33333 6.33333H10.6667C11.0349 6.33333 11.3333 6.63181 11.3333 7C11.3333 7.36819 11.0349 7.66667 10.6667 7.66667H7.33333C6.96514 7.66667 6.66667 7.36819 6.66667 7ZM7.33333 8.66667C6.96514 8.66667 6.66667 8.96514 6.66667 9.33333C6.66667 9.70152 6.96514 10 7.33333 10H10.6667C11.0349 10 11.3333 9.70152 11.3333 9.33333C11.3333 8.96514 11.0349 8.66667 10.6667 8.66667H7.33333Z" fill="white"/>
                  </svg>
                  View all orders</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer id="footer" className="text-left">&copy; <script>document.write(new Date().getFullYear())</script> eComchain Inc. All rights reserved.</footer>
  </div>
</div>
</>)

}
}

export default Dashboard